import Ajax from '@utils/ajax';
import { AxiosPromise } from 'axios';

export function getAccessLevelGroups(): AxiosPromise {
	return Ajax.get('/settings/access_levels/group_list');
}
